import React, { useState, useEffect } from 'react';
import Slider from '../lib/slider';
import useDebounce from '../lib/useDebounce';
import { UserFields, Countries, Versand } from '../lib/constants';
import { Modal } from 'react-bootstrap';

const Basket = props => {
  const [user, setUser] = useState({});
  const [basket, setBasket] = useState([]);
  const [rgAddr, setRgAddr] = useState(false);
  const [editAddr1, setEditAddr1] = useState(false);
  const [editAddr2, setEditAddr2] = useState(false);
  const [payType, setPayType] = useState('CC');
  const [spinner, setSpinner] = useState(false);
  const [quality, setQuality] = useState(false);
  const [validateUser, setValidateUser] = useDebounce('',1000);

  const { dataprovider, staticel, userinfo, setUserField, is_dev } = props;

  var total = 0;
  var ship = false;
  basket.forEach(el => {
    let preis = parseFloat(el.price) * parseFloat(el.count);
    const pen = el.pen.split('/');
    let bogen = 0;
    if (el.id_project) {
      const size = pen[1]?pen[1]:20;
      if (size.includes("x")) {
        const s = size.split("x");
        bogen = Math.ceil(el.anzSticker / (s[0]*s[1])) * el.count;
      }
      else {
        bogen = Math.ceil(el.count * el.anzSticker / (size==="60"?12:(size==="40"?24:88)));
      }
      preis = parseFloat(el.price) * bogen;
    }
    el.preis = preis;
    el.bogen = bogen;
    total += preis;

    if ((el.type==='demand' || el.type==='phys' || el.id_project > 0) && !ship) {
      ship = true;
      total += Versand;
    }
  })
  
  useEffect(() => {
    if (Object.keys(user).length === 0) return;
    if (user.id) {
      for (var i=0;i<UserFields.length;i++) {
        if (i>0 && !user[UserFields[i][0]]) {
          setEditAddr1(true);
        }
        
        if (i>0 && !user['r_'+UserFields[i][0]]) {
          setEditAddr2(true);
        }
        if (user['r_'+UserFields[i][0]]) {
          setRgAddr(true);
        }
      }
    }
    else {
      setEditAddr1(true);
    }
  }, [user]);

  const validateDone = (data) => {
    if (data.quality) {
      const adr = data.address;
      setQuality(data.quality);
      const val = {
        firstname:adr.addressee.firstName, name:adr.addressee.lastName, 
        zip:adr.geographicLocation.zip.zip, city:adr.geographicLocation.zip.city
      };
      if (adr.geographicLocation.house.houseNumber) {
        val.address = adr.geographicLocation.house.street + ' ' + adr.geographicLocation.house.houseNumber;
      }

      setUser({...user, ...val});      
    }
  }
  
  useEffect(() => {
    if (isValid && ship) {
      const us = validateUser;
      const addrsplit = us.address?us.address.match(/^(.*?)( ([^ ]+))?$/):['','','', ''];
      const val = {
        "addressee":{
           "firstName":us.firstname,
           "lastName":us.name,
           "companyName":us.institution
        },
        "geographicLocation":{
           "house":{
              "street":addrsplit[1],
              "houseNumber":addrsplit[3],
              "additionalAddress":""
           },
           "zip":{
              "zip":us.zip,
              "city":us.city
           }
        },
        "logisticLocation":{
           "postBoxNumber":""
        },
        "fullValidation":true
     }
      dataprovider.insert('post/checkaddr', val, validateDone);
    }
  }, [validateUser]);

  useEffect(() => {
    dataprovider.getList('basket', {}, setBasket);
  }, [dataprovider]);

  const setUser2 = (user) => {
    setUser(user);
    if (ship) {
      setValidateUser(user);
    }
  }

  useEffect(() => {
    if (userinfo===false) return;
    if (user.id) {
      setUser2(user);
    }
    else if (userinfo.id) {
      dataprovider.getRow('user', userinfo.id, '', setUser2);
    }
    else {
      setUser2({id:0});
    }
  }, [dataprovider, userinfo, basket]);

  
  const toggleRgAddr = (ev) => {
    if (rgAddr) {
      const us = {...user};
      for (var i=0;i<UserFields.length;i++) {
        us['r_'+UserFields[i][0]] = '';
      }
      setUser2(us);
    }
    else {
      setEditAddr2(true);
    }
    setRgAddr(!rgAddr);
  }
  
  const handleEditAddr1 = (ev) => {
    setEditAddr1(true); 
  }
  const handleEditAddr2 = (ev) => {
    setEditAddr2(true); 
  }
  const handlePayType = (z) => (ev) => {
    setPayType(z); 
  }
  const updateCartNum = (data) => {
    if (window.updateCart) {
      window.updateCart(data.cnt);
    }
  }
  const handleCount = (id, cnt) => (ev) => {
    const data = {};
    data[id] = cnt;
    dataprovider.insert('basket', {data: data}, updateCartNum);
    const nb = [];
    for (var i=0;i<basket.length;i++) {
      const it = basket[i];
      if (it.id_price===id || it.id_project===-id) {
        var cnt2 = it.count + cnt;
        if (cnt2 > 0) {
          nb.push({...it, count:cnt2});
        }
      }
      else {
        nb.push({...it});
      }
    }
    setBasket(nb);
  }
  
  const handleUserChange = (key) => (ev) => {
    setUser2({...user, [key]:ev.target.value, addrconfirm:false});
  }
  const doneInvoiceSet = (res) => {
    if (res.id) {
      updateCartNum(0);
      window.location.href ='/app#invoice/'+res.id+(payType==='CC'?'o':'r');
      window.location.reload();
    }    
    else {
      setSpinner(false);
    }
  }
  const doneUserSet = (res) => {
    if (res.id) {
      const us = {...user, id:res.id};
      setUser2(us);
      setUserField('id', res.id);
      dataprovider.insert('invoice', {'payType':payType}, doneInvoiceSet);
    }
    else {
      setSpinner(false);
    }
  }
  const confirmAddr = (ev) => {
    setUser2({...user, addrconfirm:true});
  }

  const handleBestellen = (ev) => {
    setSpinner(true);
    setEditAddr1(false);
    setEditAddr2(false);
    const data = {...user, rgaddr:rgAddr, front:true};
    if (!userinfo.id) {
      dataprovider.insert('user', data, doneUserSet);
    }
    else if (editAddr1 || editAddr2) {
      dataprovider.update('user/'+userinfo.id, data, doneUserSet);
    }
    else {
      doneUserSet(true);
    }
  }
  var isValid = true;
  const inValid = {};
  if (!userinfo || !userinfo.id) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!re.test(String(user.email).toLowerCase())) {
      inValid.email = true;
      isValid = false;
    }
    const re2 = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/
    if (!re2.test(String(user.password))) {
      inValid.password = true;
      isValid = false;
    }
    if (user.password!==user.password_rep) {
      inValid.password_rep = true;
      isValid = false;
    }  
  }

  for (var i=0;i<UserFields.length;i++) {
    var f = UserFields[i][0];
    if (f==='country' && !user[f]) user[f] = 'CH';
    if (f==='zip' && (!user[f] || user[f].length<4 || user[f].length>5)) {
      inValid[f] = true;
      isValid = false;
    }
    if (i>0 && !user[f]) {
      inValid[f] = true;
      isValid = false;
    }
    if (rgAddr && i>0 && !user['r_'+f]) {
      if (f==='country' && !user['r_'+f]) user['r_'+f] = 'CH';
      inValid['r_'+f] = true;
      isValid = false;
    }
  }

  const isConfirmed = isValid && (quality==='DOMICILE_CERTIFIED' || user.addrconfirm || !ship);
  
  return (
    <>
      <Slider staticel={staticel} page={2} is_dev={is_dev} />
      <div className="container pt-5 mt-5">
        <div className="row align-items-top">
          <div className="col-lg-6 pe-4">
      {(!userinfo || !userinfo.id) &&
           <>
            <h6>Registration (Bereits registriert? Hier <button className="link" data-bs-toggle="modal" data-bs-target="#loginModal">anmelden</button>)</h6>
            <div className="row mb-2 align-items-center">
              <div className="col-3 text-end">E-Mail</div>
              <div className="col-9">
                <input type="email" value={user.email} onChange={handleUserChange('email')} className={"form-control"+(inValid.email?" is-invalid":"")} />
              </div>
            </div>
            <div className="row mb-2 align-items-center">
              <div className="col-3 text-end">Passwort</div>
              <div className="col-9">
                <input type="password" value={user.password} onChange={handleUserChange('password')} className={"form-control"+(inValid.password?" is-invalid":"")} />
                <div className="invalid-feedback">Min. 8 Zeichen, muss Gross- und Kleinbuchstaben sowie Zahlen enthalten.</div>
              </div>
            </div>
            <div className="row mb-2 align-items-center">
              <div className="col-3 text-end">Passwort wiederholen</div>
              <div className="col-9">
                <input type="password" value={user.password_rep} onChange={handleUserChange('password_rep')} className={"form-control"+(inValid.password_rep?" is-invalid":"")} />
              </div>
            </div>
           </> 
      }
            <h6 className="mt-2">
              {rgAddr?"Zustelladresse":"Rechnungs- und Zustelladresse"}
              {!editAddr1 && <i className={"bi bi-pencil ms-2"} onClick={handleEditAddr1}></i>}
            </h6>
      {editAddr1 ?
        <>
        {UserFields.map((el, k) => (
            <div className="row mb-2 align-items-center" key={el[0]}>
              <div className="col-3 text-end">{el[1]}</div>
          {el[0]==='country'?
              <div className="col-9">
                <select value={user[el[0]]} onChange={handleUserChange(el[0])} className="form-select">
            {Countries.map(c=>(
                  <option value={c.value} key={c.value}>{c.text}</option>
            ))}
                </select>
              </div>
          :
              <div className="col-9">
                <input value={user[el[0]]} onChange={handleUserChange(el[0])} maxLength="35" className={"form-control"+(inValid[el[0]]?" is-invalid":"")} />
              </div>
          }
            </div>
        ))}
        </>
        :
            <div className="row mb-2 ">
              <div className="col-3 text-end"></div>
              <div className="col-9">
                {user.institution}<br/>
                {user.firstname} {user.name}<br/>
                {user.address}<br/>
                {user.zip} {user.city}<br/>
                {user.country}
              </div>
            </div>
      }
        {(ship && isValid && quality!=='DOMICILE_CERTIFIED' && !user.addrconfirm) && 
            <div style={{ borderRadius: '0.5em', border: '2px solid orange', padding: '0.5em', margin: '0.5em 0'}}>
          {quality==='CERTIFIED'? 
              <p>
                Die angegebene Person wurde bei der Post an dieser Adresse nicht gefunden.
                Ist der Briefkasten an dieser Adresse mit <b>{user.institution?user.institution:(user?.firstname+' '+user?.name)}</b> angeschrieben?<br />
                <button type="button" className="btn btn-primary mt-2" onClick={confirmAddr}>Bestätigen</button>
              </p>
          :
              <p>
                Die angegebene Adresse wurde bei der Post als ungültig taxiert.
                Ist sie korrekt erfasst und der Briefkasten genau so angeschrieben?<br />
                <button type="button" className="btn btn-primary mt-2" onClick={confirmAddr}>Bestätigen</button>
              </p>
          }    
            </div>  
        }
        
            <input className="form-check-input" type="checkbox" checked={rgAddr} onChange={toggleRgAddr} /> Abweichende Rechnungsadresse
            {!editAddr2 && <i className={"bi bi-pencil ms-2"} onClick={handleEditAddr2}></i>}
        {rgAddr && editAddr2 && UserFields.map((el, k) => (
            <div className="row mb-2 align-items-center" key={'r_'+el[0]}>
              <div className="col-3 text-end">{el[1]}</div>
          {el[0]==='country'?
              <div className="col-9">
                <select value={'r_'+user[el[0]]} onChange={handleUserChange('r_'+el[0])} className="form-select">
            {Countries.map(c=>(
                  <option value={c.value} key={c.value}>{c.text}</option>
            ))}
                </select>
              </div>
          :
              <div className="col-9">
                <input value={user['r_'+el[0]]} onChange={handleUserChange('r_'+el[0])} className={"form-control"+(inValid['r_'+el[0]]?" is-invalid":"")} />
              </div>
          }
            </div>
        ))}
        {!editAddr2 &&
            <div className="row mb-2 ">
              <div className="col-3 text-end"></div>
              <div className="col-9">
                {user.r_institution}<br/>
                {user.r_firstname} {user.r_name}<br/>
                {user.r_address}<br/>
                {user.r_zip} {user.r_city}<br/>
                {user.r_country}
              </div>
            </div>
        }
        {basket.length > 0 && total>0 &&
            <div>
              <h6 className="mt-4">Zahlung</h6>
              <div className="form-check">
                <input className="form-check-input" type="radio" id="zahlRG" checked={payType==='RG'} onChange={handlePayType('RG')} />
                <label className="form-check-label" htmlFor="zahlRG">
                  Vorauskasse (Freischaltung / Versand erfolgt nach Zahlungseingang)
                </label>
              </div>
              <div className="form-check">
                <input className="form-check-input" type="radio" id="zahlCC" checked={payType==='CC'} onChange={handlePayType('CC')} />
                <label className="form-check-label" htmlFor="zahlCC">
                  Twint (alixon gmbh) / Kreditkarte (Freischaltung / Versand erfolgt sofort)
                </label>
              </div>
            </div>
        }
        {basket.length > 0 &&
            <div>
              <button type="button" className={"btn btn-"+(isConfirmed?"primary":"secondary")+" mt-4"}  disabled={!isConfirmed} onClick={handleBestellen}>{total>0?"Kostenpflichtig bestellen: CHF "+total.toFixed(2):"Gratis bestellen"}</button>
            </div>
        }
          </div>
          <div className="col-lg-6">
            <div className="row">
        {!basket.length && <h2>Warenkorb ist leer</h2>}
        {basket.map(el => {
          const pen = el.pen.split('/');
          return (
              <div className="row mb-1 mt-3 p-3" style={{backgroundColor:'#f2f2f2', borderRadius:'15px'}} key={el.id}>
                <div className="col-12 col-sm-8">
                  <h6>
                    <a href={el.id_product?"app#shop/s"+el.id_product:"app#creator/"+el.id_project}>{el.title?el.title:el.proj_name}</a>
                    {el.pen!=='-' && <span className="ms-5" style={{color:pen[0]==='tiptoi'?'#F09313':'#64B32D'}}>
                      {pen[0]}{pen[1]?' / '+pen[1]:''}
                    </span>}
                  </h6>
                  <p>{el.text}</p>
                </div>
                <div className="col-6 col-sm-2 text-center">
                  {el.count}{el.bogen?' ('+el.bogen+' Bogen)':''}<br/>
                  <i className="bi bi-plus-circle ms-2" onClick={handleCount(el.id_price?el.id_price:-el.id_project, 1)}></i>
                  <i className="bi bi-dash-circle ms-2" onClick={handleCount(el.id_price?el.id_price:-el.id_project, -1)}></i>
                  <i className="bi bi-x-circle ms-2" onClick={handleCount(el.id_price?el.id_price:-el.id_project, -el.count)}></i>
                </div>
                <div className="col-3 col-sm-1 text-end">
                  {parseFloat(el.price).toFixed(2)}
                </div>
                <div className="col-3 col-sm-1 text-end">
                  {el.preis.toFixed(2)}
                </div>
                
              </div>
        )})}
        {ship && 
               <div className="row mt-1 px-3">
                <div className="col-8"><h6>Versand</h6></div>
                <div className="col-2 text-end"></div>
                <div className="col-1 text-end"></div>
                <div className="col-1 text-end">{Versand.toFixed(2)}</div>
              </div>
        }
              <div className="row mb-1 p-3">
                <div className="col-8"><h6>Total</h6></div>
                <div className="col-2 text-end"></div>
                <div className="col-1 text-end"></div>
                <div className="col-1 text-end">{total.toFixed(2)}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal show={spinner} backdrop="static" keyboard={false} centered>
        <Modal.Header>
          <Modal.Title>Rechnung wird erstellt ...</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="spinner-border d-block mx-auto" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default Basket;
